export function initRevocationForms(): void {
    document.querySelectorAll<HTMLFormElement>('.js-revocation-form').forEach($revocationForm => {
        new RevocationForm($revocationForm);
    });
}

class RevocationForm {
    $form: HTMLFormElement;
    $reasonSelect: HTMLSelectElement;

    constructor($form: HTMLFormElement) {
        this.$form = $form;
        this.$reasonSelect = this.$form.querySelector('.js-revocation-form-select') as HTMLSelectElement;

        if (!this.$reasonSelect) {
            return;
        }

        this.onReasonSelectChange();
        this.$reasonSelect.addEventListener('change', this.onReasonSelectChange.bind(this));
    }

    /**
     * Affichage des champs explicatifs en fonction de la sélection dans le formulaire de révocation
     * 
     * @return {void}
     */
    onReasonSelectChange(): void {
        const $option = this.$reasonSelect.selectedOptions.item(0);
        const $divs = this.$form.querySelectorAll<HTMLElement>('div[data-is-other]');

        $divs?.forEach($div => {
            $div.classList.add('hidden');

            if ($option?.dataset.isOther === $div.dataset.isOther) {
                $div.classList.remove('hidden');
            }
        });

        // On vide les champs masqués
        $divs?.forEach($div => {
            if ($div.classList.contains('hidden')) {
                const $input = $div.querySelector<HTMLInputElement>('input');
                if ($input) {
                    $input.value = '';
                }
            }
        });
    }
}
